/* pc-holo-slider.js: moved out of sections/holo-product-slider.liquid inline script (Page Weight, Oct 2026). */
(function () {
  if (window.__pcHoloJs) return;
  window.__pcHoloJs = true;
  (function () {
    function initHolo(root) {
      if (!root || root.getAttribute('data-holo-ready')) return;
      root.setAttribute('data-holo-ready', '1');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var maxTilt = parseFloat(root.getAttribute('data-tilt')) || 14;
      var noHover = window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches;

      if (!noHover) root.querySelectorAll('[data-holo-card]:not(.is-plain)').forEach(function (card) {
        var raf = null;
        function move(x, y, onBtn) {
          var r = card.getBoundingClientRect();
          var px = Math.min(Math.max((x - r.left) / r.width, 0), 1);
          var py = Math.min(Math.max((y - r.top) / r.height, 0), 1);
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () {
            card.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
            card.style.setProperty('--my', (py * 100).toFixed(1) + '%');
            if (!reduce) {
              // hold the card still while the pointer is on Add to Cart, and ease the tilt near the bottom edge
              // on Add to Cart the card freezes exactly where it is, so the button never moves under the pointer mid-click
              if (!onBtn) {
                var t = maxTilt * (py > 0.7 ? Math.max(0.25, 1 - (py - 0.7) / 0.3 * 0.75) : 1);
                card.style.setProperty('--ry', ((px - 0.5) * 2 * t).toFixed(2) + 'deg');
                card.style.setProperty('--rx', ((0.5 - py) * 2 * t).toFixed(2) + 'deg');
              }
            }
            card.style.setProperty('--o', '1');
          });
        }
        function reset() {
          if (raf) cancelAnimationFrame(raf);
          card.classList.remove('is-active', 'is-on-atc');
          card.style.setProperty('--rx', '0deg');
          card.style.setProperty('--ry', '0deg');
          card.style.setProperty('--mx', '50%');
          card.style.setProperty('--my', '50%');
          card.style.setProperty('--o', '0');
        }
        card.addEventListener('pointerenter', function () { card.classList.add('is-active'); });
        card.addEventListener('pointermove', function (e) {
          var onBtn = !!(e.target && e.target.closest && e.target.closest('[data-holo-atc]'));
          card.classList.add('is-active'); card.classList.toggle('is-on-atc', onBtn); move(e.clientX, e.clientY, onBtn);
        });
        card.addEventListener('pointerleave', reset);
        card.addEventListener('pointercancel', reset);
      });


      /* ---- Add to cart buttons ---- */
      root.querySelectorAll('[data-holo-atc]').forEach(function (btn) {
        var label = btn.querySelector('.holo-atc-label');
        var original = label ? label.textContent : '';
        var timer = null;
        function flash(cls, text, ms) {
          clearTimeout(timer);
          btn.classList.remove('is-loading', 'is-added', 'is-error');
          if (cls) btn.classList.add(cls);
          if (label && text) label.textContent = text;
          timer = setTimeout(function () { btn.classList.remove(cls); if (label) label.textContent = original; }, ms);
        }
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (btn.classList.contains('is-loading')) return;
          btn.classList.add('is-loading');
          var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification') || document.querySelector('cart-items');
          var fd = new FormData();
          fd.append('id', btn.getAttribute('data-variant-id'));
          fd.append('quantity', '1');
          if (cart && typeof cart.getSectionsToRender === 'function') {
            fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
            fd.append('sections_url', window.location.pathname);
            if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
          }
          var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
          fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res.status) {
                flash('is-error', 'Max in cart', 2200);
                if (typeof window.pushErrorMessage === 'function') window.pushErrorMessage(res.description || res.message);
                return;
              }
              flash('is-added', 'Added', 1800);
              if (cart && typeof cart.renderContents === 'function') {
                cart.renderContents(res);
                if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
              } else if (!cart) {
                window.location = (window.routes && window.routes.cart_url) || '/cart';
                return;
              }
              document.dispatchEvent(new CustomEvent('afterCartChanged', { detail: { productVariantId: fd.get('id'), source: 'holo-slider', cartData: res } }));
            })
            .catch(function () { flash('is-error', 'Try again', 2200); });
        });
      });

      var track = root.querySelector('[data-holo-track]');
      var prev = root.querySelector('[data-holo-prev]');
      var next = root.querySelector('[data-holo-next]');
      if (!track) return;
      function step() {
        var s = track.querySelector('.holo-slide');
        return s ? s.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : track.clientWidth;
      }
      function update() {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();

      /* ---- Auto-shine for phones & tablets (no hover) ----
         The card that snaps into view gets a holo sweep: glare and rainbow glide across it with a gentle tilt. */
      if (false && noHover && !reduce) { /* off: holo effects only on hover; the endless sweep made phones lag (Trevor, Oct 17) */
        var cards = Array.prototype.slice.call(root.querySelectorAll('[data-holo-card]:not(.is-plain)'));
        var SWEEP = 2600, PAUSE = 1200;
        var current = null, startTime = 0, rafId = null, onScreen = true, settleTimer = null;

        function setVars(card, mx, my, rx, ry, o) {
          card.style.setProperty('--mx', mx.toFixed(1) + '%');
          card.style.setProperty('--my', my.toFixed(1) + '%');
          card.style.setProperty('--rx', rx.toFixed(2) + 'deg');
          card.style.setProperty('--ry', ry.toFixed(2) + 'deg');
          card.style.setProperty('--o', o.toFixed(3));
        }
        function clearCard(card) {
          if (!card) return;
          card.classList.remove('is-active');
          setVars(card, 50, 50, 0, 0, 0);
        }
        function pickCard() {
          var tr = track.getBoundingClientRect(), best = null, bestVis = 0;
          cards.forEach(function (c) {
            var r = c.getBoundingClientRect();
            var vis = Math.min(r.right, tr.right) - Math.max(r.left, tr.left);
            if (vis > bestVis + 1) { bestVis = vis; best = c; }
          });
          return best;
        }
        function frame(t) {
          rafId = null;
          if (!current || !onScreen) return;
          var cycle = (t - startTime) % (SWEEP + PAUSE);
          if (cycle < SWEEP) {
            var p = cycle / SWEEP;
            var e = 0.5 - 0.5 * Math.cos(Math.PI * p);
            var arc = Math.sin(Math.PI * p);
            setVars(current, -10 + 120 * e, 25 + 50 * e, arc * maxTilt * 0.35, (e - 0.5) * 2 * maxTilt * 0.6, arc);
          } else {
            setVars(current, 50, 50, 0, 0, 0);
          }
          rafId = requestAnimationFrame(frame);
        }
        function startOn(card) {
          if (current && current !== card) clearCard(current);
          current = card;
          if (!card) return;
          card.classList.add('is-active');
          startTime = performance.now();
          if (!rafId && onScreen) rafId = requestAnimationFrame(frame);
        }
        function stop() {
          if (rafId) cancelAnimationFrame(rafId);
          rafId = null;
          clearCard(current);
          current = null;
        }
        track.addEventListener('scroll', function () {
          if (current) stop();
          clearTimeout(settleTimer);
          settleTimer = setTimeout(function () { startOn(pickCard()); }, 180);
        }, { passive: true });
        cards.forEach(function (c) {
          c.addEventListener('touchstart', function () { if (c !== current) startOn(c); else startTime = performance.now(); }, { passive: true });
        });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            onScreen = entries[0].isIntersecting;
            if (onScreen) { if (!current) startOn(pickCard()); else if (!rafId) rafId = requestAnimationFrame(frame); }
          }, { threshold: 0.25 }).observe(root);
        }
        startOn(pickCard());
      }
    }
    function initAll() { document.querySelectorAll('[data-holo-section]').forEach(initHolo); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
    document.addEventListener('shopify:section:load', initAll);
  })();
})();
